import { regionIdSelector } from 'shared/selectors/offerData/geo/regionIdSelector';
import { IState } from 'shared/store';

export const getMortgageBannerUrl = (state: IState): string | null => {
  const regionId = regionIdSelector(state);

  if (!regionId) {
    return null;
  }

  return `/cat.php/?deal_type=sale&engine_version=2&from_developer=1&offer_type=flat&is_discount_mortgage=1&region=${regionId}`;
};
